// extracted by mini-css-extract-plugin
export default {"target_product":"Z3","retake":"a4","product_info":"b4","icon":"c4","target_image":"e4","background":"f4","product_info_desktop":"g4","info":"h4","title":"i4","benefits":"j4","benefit":"k4","accordeon_wrapper":"l4","ingredients_wrapper":"m4","info_wrapper":"n4","product_wrapper":"o4"};
    if(module.hot) {
      // 1715276860137
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  